import classNames from 'classnames';
import { useContext } from 'react';
import { AppContext } from '@rabbit/app-context';

export interface SliderImageProps {
  imageUrl: string;
  size: 'sm' | 'md' | 'NLIC';
  subtitle: string;
  title: string;
  mpn: string;
  onClick: any; //todo
}

const dynamicStyles = {
  base: 'bg-contain bg-no-repeat bg-center border border-gray-200 cursor-pointer bg-white hover:border-primary-500 transition-all duration-300',
  sm: 'rounded-t-xl w-[159px] lg:w-[225px] h-[159px]',
  md: 'rounded-t-lg w-full h-[171px]',
  NLIC: 'rounded-t-lg w-full h-[90px]',
  containerSM: 'lg:w-[225px] cursor-pointer group',
  containerMD: 'w-full cursor-pointer group',
};

export function SearchImage({
  imageUrl,
  size,
  subtitle,
  title,
  mpn,
  onClick,
}: SliderImageProps) {
  const { config } = useContext(AppContext);

  return (
    <div
      className={classNames({
        [`${dynamicStyles.containerMD}`]: size === 'md',
        [`${dynamicStyles.containerSM}`]: size === 'sm',
      })}
    >
      <div className="overflow-hidden rounded-t-lg">
        <div
          style={{ backgroundImage: 'url(' + imageUrl + ')' }}
          className={classNames(`${dynamicStyles.base} transform group-hover:scale-105`, {
            [`${dynamicStyles.md}`]: size === 'md',
            [`${dynamicStyles.sm}`]: size === 'sm',
            [`${dynamicStyles.NLIC}`]: size === 'NLIC',
          })}
          onClick={onClick}
        ></div>
      </div>
      <div className="p-3 hover:bg-gray-50 transition-colors duration-300 rounded-b-lg border-x border-b border-gray-200 group-hover:border-primary-500">
        <div className="flex items-center">
          <span className="inline-block px-2 py-1 text-xs font-semibold text-primary-700 bg-primary-50 rounded-full mb-2">
            {subtitle}
          </span>
        </div>
        {config.VENDABLES.SKU_SEARCH ? (
          <div>
            <p className="w-full text-base font-medium text-gray-900 truncate hover:text-primary-700 transition-colors duration-200">
              {title}
            </p>
            <p className="text-sm text-primary-700 font-medium mt-1 flex items-center">
              <span className="text-xs text-gray-500 mr-1">MPN:</span> {mpn}
            </p>
          </div>
        ) : (
          <p className="w-full text-base font-medium text-gray-900 truncate hover:text-primary-700 transition-colors duration-200">{title}</p>
        )}
        <button
          onClick={onClick}
          className="mt-3 text-sm text-white bg-primary-600 hover:bg-primary-700 font-medium px-4 py-2 rounded-lg w-full transition-colors duration-200 flex items-center justify-center"
        >
          View Details
        </button>
      </div>
    </div>
  );
}

export default SearchImage;
